import React, { useEffect, useState } from 'react';
import { Redirect, useParams } from 'react-router-dom';
import { Helmet } from "react-helmet";
import Button from 'components/Button/Button';
import SettingsContext from 'contexts/SettingsContext';
import useCompetitionEntryContext from 'contexts/useCompetitionEntryContext';
import competitionEntryService from 'services/competitionEntryService';
import analyticsService from 'services/analyticsService';
import SignUp from 'containers/Forms/SignUp';
import useEffectOnce from 'hooks/useEffectOnce';
import PlayerBadge from 'components/PlayerBadge/PlayerBadge';
import SummaryTsandCs from 'components/SummaryTsandCs/SummaryTsandCs';
import ThankYouHero from './ThankYouHero';
import Prize from 'components/Prize/Prize';
import Carousel from 'components/Carousel/Carousel';
import FocusTrap from 'focus-trap-react';
import Stage from 'components/Confetti/Stage';
import NpsBanner from 'components/NpsBanner/NpsBanner';
import timer from 'utils/timer';
import ReactDOM from 'react-dom';
import Link from 'components/Link/Link';



//voucher images
import thankyoukeyvis_voucher100_dt from 'assets/images/campaign/keyvis/thankyou/thankyoukeyvis_voucher100_dt.png';
import thankyoukeyvis_voucher100_dt_2x from 'assets/images/campaign/keyvis/thankyou/thankyoukeyvis_voucher100_dt@2x.png';
import thankyoukeyvis_voucher100_tab from 'assets/images/campaign/keyvis/thankyou/thankyoukeyvis_voucher100_tab.png';
import thankyoukeyvis_voucher100_tab_2x from 'assets/images/campaign/keyvis/thankyou/thankyoukeyvis_voucher100_tab@2x.png';
import thankyoukeyvis_voucher100_mob from 'assets/images/campaign/keyvis/thankyou/thankyoukeyvis_voucher100_mob.png';
import thankyoukeyvis_voucher100_mob_2x from 'assets/images/campaign/keyvis/thankyou/thankyoukeyvis_voucher100_mob@2x.png';

import thankyoukeyvis_voucher50_dt from 'assets/images/campaign/keyvis/thankyou/thankyoukeyvis_voucher50_dt.png';
import thankyoukeyvis_voucher50_dt_2x from 'assets/images/campaign/keyvis/thankyou/thankyoukeyvis_voucher50_dt@2x.png';
import thankyoukeyvis_voucher50_tab from 'assets/images/campaign/keyvis/thankyou/thankyoukeyvis_voucher50_tab.png';
import thankyoukeyvis_voucher50_tab_2x from 'assets/images/campaign/keyvis/thankyou/thankyoukeyvis_voucher50_tab@2x.png';
import thankyoukeyvis_voucher50_mob from 'assets/images/campaign/keyvis/thankyou/thankyoukeyvis_voucher50_mob.png';
import thankyoukeyvis_voucher50_mob_2x from 'assets/images/campaign/keyvis/thankyou/thankyoukeyvis_voucher50_mob@2x.png';

import thankyoukeyvis_tickets_dt from 'assets/images/campaign/keyvis/thankyou/thankyoukeyvis_tickets_dt.png';
import thankyoukeyvis_tickets_dt_2x from 'assets/images/campaign/keyvis/thankyou/thankyoukeyvis_tickets_dt@2x.png';
import thankyoukeyvis_tickets_tab from 'assets/images/campaign/keyvis/thankyou/thankyoukeyvis_tickets_tab.png';
import thankyoukeyvis_tickets_tab_2x from 'assets/images/campaign/keyvis/thankyou/thankyoukeyvis_tickets_tab@2x.png';
import thankyoukeyvis_tickets_mob from 'assets/images/campaign/keyvis/thankyou/thankyoukeyvis_tickets_mob.png';
import thankyoukeyvis_tickets_mob_2x from 'assets/images/campaign/keyvis/thankyou/thankyoukeyvis_tickets_mob@2x.png';

//voucher images ROI

import thankyoukeyvis_voucher100_dt_roi from 'assets/images/campaign/keyvis/thankyou/roi/thankyoukeyvis_voucher100_dt_roi.png';
import thankyoukeyvis_voucher100_dt_roi_2x from 'assets/images/campaign/keyvis/thankyou/roi/thankyoukeyvis_voucher100_dt_roi@2x.png';
import thankyoukeyvis_voucher100_tab_roi from 'assets/images/campaign/keyvis/thankyou/roi/thankyoukeyvis_voucher100_tab_roi.png';
import thankyoukeyvis_voucher100_tab_roi_2x from 'assets/images/campaign/keyvis/thankyou/roi/thankyoukeyvis_voucher100_tab_roi@2x.png';
import thankyoukeyvis_voucher100_mob_roi from 'assets/images/campaign/keyvis/thankyou/roi/thankyoukeyvis_voucher100_mob_roi.png';
import thankyoukeyvis_voucher100_mob_roi_2x from 'assets/images/campaign/keyvis/thankyou/roi/thankyoukeyvis_voucher100_mob_roi@2x.png';

import thankyoukeyvis_voucher50_dt_roi from 'assets/images/campaign/keyvis/thankyou/roi/thankyoukeyvis_voucher50_dt_roi.png';
import thankyoukeyvis_voucher50_dt_roi_2x from 'assets/images/campaign/keyvis/thankyou/roi/thankyoukeyvis_voucher50_dt_roi@2x.png';
import thankyoukeyvis_voucher50_tab_roi from 'assets/images/campaign/keyvis/thankyou/roi/thankyoukeyvis_voucher50_tab_roi.png';
import thankyoukeyvis_voucher50_tab_roi_2x from 'assets/images/campaign/keyvis/thankyou/roi/thankyoukeyvis_voucher50_tab_roi@2x.png';
import thankyoukeyvis_voucher50_mob_roi from 'assets/images/campaign/keyvis/thankyou/roi/thankyoukeyvis_voucher50_mob_roi.png';
import thankyoukeyvis_voucher50_mob_roi_2x from 'assets/images/campaign/keyvis/thankyou/roi/thankyoukeyvis_voucher50_mob_roi@2x.png';



import prizeList from 'utils/prizes';

import './Thankyou.scss';
import useSettingsContext from 'contexts/useSettingsContext';


export default () => {
  let { entryPublicId } = useParams();  

  let [settings, setSettings] = React.useContext(SettingsContext);
  let settings2  = useSettingsContext();
  let compState = settings.competitionStatus.openState;
  let compPhaseId = settings.competitionStatus.currentPhasePublicId;
  let competitionIsOpen = compState === "Open";
  let competitionIsMopup = compPhaseId === "mop-up";

  let [showVideo, setShowVideo] = useState(false);
  let [videoSource, setVideoSource] = useState(null);
  let [videoSourceDesk, setVideoSourceDesk] = useState(null);
  let [selectedPrize, setSelectedPrize] = useState(null);
  let [country, setCountry] = useState(null);

  let competitionEntryContext = useCompetitionEntryContext();
  let [entry, setEntry] = useState(competitionEntryContext.result);

  let [showNps, setShowNps] = useState(null);

  let [currency, setCurrency] = useState('');

  useEffect(() => {
    const scrollToTop = () => {
      document.body.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    };
  
    scrollToTop();
  }, []);

  useEffect(() => {
    switch (settings.country) {
      case "ROI":
        setCurrency("€");
        break;
      case "GB":
      case "NI":
      case "UK":
        setCurrency("£");
        break;
      default:
        setCurrency("£/€");
        break;
    }

    setCountry(settings.country);
  }, [settings.country]);

  useEffect(() => {
    async function fetchData() {
      await competitionEntryService.getCompetitionEntry(entryPublicId)
      .then((result) => {       
          if(result) {            
            setEntry(result);

            if(result.country && result.country !== undefined && result.country !== null){
              sessionStorage && sessionStorage.setItem('cadburyfc.country', result.country);
              settings2.setCountry(result.country);
            }

            if(result.hasCustomerSurveyScore) {              
              setShowNps(false);
            } else {              
              timer.delay(2500).then(() => setShowNps(true));
            }

            var email = competitionEntryContext.email;
            //Had to go here, as not triggered on last page
            if (email != null) {
              // Save email to DataLayer - GTM uses this to pass to Lytics (Only if the user has accepted targeting cookies)

              analyticsService.logEvent("signup", "entry_registration", {
                location: "thankyou_page",
                label: "email capture",
                url: email
              });

              analyticsService.logEvent("signup", "entry_registration", {
                location: "thankyou_page",
                label: "registration success"
              });

              if (result.hasWon) {
                analyticsService.logEvent('signup', 'entry_registration', {
                  location: "thankyou_page",
                  label: "prize",
                  url: result.prizePublicId
                });
              }
            }
            
          } 
          
      })
      .catch(err => console.log(err) );
    }

    if (entryPublicId && !entry) {
      fetchData();
    }

  }, [entryPublicId]);

  // useEffectOnce(() => {
  //   timer.delay(2500).then(() => setShowNps(true));
 
  // });

 
  if (competitionIsOpen && ((entry !== null && !entry.entryPublicId) || !entryPublicId)) {
    return (
      <Redirect to="/" />
    )
  }


  const handleShowVideo = (video,  videoDesk) => {
    setVideoSource(video);
    setVideoSourceDesk(videoDesk);
    setShowVideo(true);

  };

  const handleCloseVideo = () => {
    setShowVideo(false);
    setVideoSource(null);
  };

  const renderNpsBanner = (entryPublicId) => {
    if (!entryPublicId) return null;
    return <NpsBanner onClose={() => setShowNps(false)} competitionEntryPublicId={entryPublicId} show={showNps} />
  }

  const renderWinnerImage = (prizeTier) => {
    return (
      <>
        {
          {
            "match-ticket":
              <ThankYouHero
                image={thankyoukeyvis_tickets_mob}
                image2x={thankyoukeyvis_tickets_mob_2x}
                imageTab={thankyoukeyvis_tickets_tab}
                imageTab2x={thankyoukeyvis_tickets_tab_2x}
                imageDesk={thankyoukeyvis_tickets_dt}
                imageDesk2x={thankyoukeyvis_tickets_dt_2x}
                alt="Congratulations, you've won Match Day tickets!"
              />,
            "voucher-100":
              country === "ROI" ? (
                <ThankYouHero
                  image={thankyoukeyvis_voucher100_mob_roi}
                  image2x={thankyoukeyvis_voucher100_mob_roi_2x}
                  imageTab={thankyoukeyvis_voucher100_tab_roi}
                  imageTab2x={thankyoukeyvis_voucher100_tab_roi_2x}
                  imageDesk={thankyoukeyvis_voucher100_dt_roi}
                  imageDesk2x={thankyoukeyvis_voucher100_dt_roi_2x}
                  alt="Congratulations, you've won a €100 e-voucher!"
                />
              ) : (
                <ThankYouHero
                  image={thankyoukeyvis_voucher100_mob}
                  image2x={thankyoukeyvis_voucher100_mob_2x}
                  imageTab={thankyoukeyvis_voucher100_tab}
                  imageTab2x={thankyoukeyvis_voucher100_tab_2x}
                  imageDesk={thankyoukeyvis_voucher100_dt}
                  imageDesk2x={thankyoukeyvis_voucher100_dt_2x}
                  alt="Congratulations, you've won a £100 e-voucher!"
                />
              ),
            "voucher-50":
              country === "ROI" ? (
                <ThankYouHero
                  image={thankyoukeyvis_voucher50_mob_roi}
                  image2x={thankyoukeyvis_voucher50_mob_roi_2x}
                  imageTab={thankyoukeyvis_voucher50_tab_roi}
                  imageTab2x={thankyoukeyvis_voucher50_tab_roi_2x}
                  imageDesk={thankyoukeyvis_voucher50_dt_roi}
                  imageDesk2x={thankyoukeyvis_voucher50_dt_roi_2x}
                  alt="Congratulations, you've won a €50 e-voucher"
                />
                ) : (
                <ThankYouHero
                  image={thankyoukeyvis_voucher50_mob}
                  image2x={thankyoukeyvis_voucher50_mob_2x}
                  imageTab={thankyoukeyvis_voucher50_tab}
                  imageTab2x={thankyoukeyvis_voucher50_tab_2x}
                  imageDesk={thankyoukeyvis_voucher50_dt}
                  imageDesk2x={thankyoukeyvis_voucher50_dt_2x}
                  alt="Congratulations, you've won a £50 e-voucher!"
                />
              ),
          }[prizeTier]
        }
      </>
    );
  };
    


  const renderWinner = () => {
    return (
      <>
        <Helmet>
          <meta charSet="utf-8" />
          <title>Congratulations! | Cadbury FC - Game Changing Wins</title>
        </Helmet>

        {renderWinnerImage(entry.prizePublicId)}

        <section  className="layout-general layout-wrapper thankyou">
          <div className="layout-container layout-container--center layout-container--slim">

            {
              (entry.prizePublicId.indexOf('match-ticket') > -1) ? (
               //(prizePublicId.indexOf('match-ticket') > -1) ? (
               <>
                               <h1 className='type-h1'>You've won* match tickets</h1>
               </>

              ) :
                (entry.prizePublicId.indexOf('voucher-50') > -1) ? (
                 //(prizePublicId.indexOf('voucher-50') > -1) ? (
                  <h1 className='type-h1'>You've won* a {currency}50 voucher</h1>
                ) : (

                    <h1 className='type-h1'>You've won* a {currency}100 voucher</h1>
                )
            }
            <div className="goldbar"></div>

           {/*<div className={entry.prizePublicId.indexOf('signed-shirt') > -1 ? 'thankyou__row' : 'thankyou__row thankyou__row--fullwidth'}>*/}


            <div className='thankyou__textcont'>
              
              <div className="thankyou__para">
                {
                  {
                    "voucher-50": <p>Congratulations! There's a game changing shopping voucher with your name on it – just make sure you validate your entry <strong>within 14 days</strong> via the email link to make it official.</p>,
                    "voucher-100": <p>Congratulations! There's a game changing shopping voucher with your name on it – just make sure you validate your entry <strong>within 14 days</strong> via the email link to make it official.</p>,
                    "match-ticket": <p>Congratulations! There’s a pair of match tickets with your name on – just make sure you validate your entry <strong>within 14 days</strong> via the email link to make it official.</p>,
                  }[entry.prizePublicId]
                   //}[prizePublicId]
                }

                <p className="gold">
                <strong>You’re also still in the running to win a game changing player experience. The draw will take place after 28/07/25, so keep an eye on your inbox! </strong>
                </p>
                <p>
                In the meantime, why not find out more about our incredible lineup? Click below to hear the inspirational stories that have made them who they are today.
                </p>
                <p>
                *Subject to availability and verification checks. Entry must be validated via your unique email link within 14 days (don’t forget to check your junk folder). 
                </p>
              </div>
            </div>

          </div>

          {renderNpsBanner(entryPublicId)}
          {/* <canvas id="confetti-canvas" className="layout-general__confetti" width="100%" height="100%" />*/}
        </section>
        {/*Carousel Start*/}
        <section className="layout-general layout-general--full layout-wrapper overflowx-hidden bg-secondary">
          <div className="layout-container layout-container--center layout-container--wide prize-select">
            <h1 className="type-h1">Meet Players</h1>
            <h1 className="type-h2 type-h2--thin type-h2--gold">who inspire</h1>
            <div className="prize-select__intro">
              <p>Our game changing players wouldn't be where they are today without the kindness of their friends and family. Learn more about their inspirational stories here.</p>
            </div>
            <form>
              <div className="prize-select__list">

                <Carousel 
                  className="prize-select__carousel"
                  params={{
                    watchOverflow: true,
                    spaceBetween: 30,
                    slidesPerView: 1,
                    centeredSlides: false,
                    pagination: {
                      el: '.swiper-pagination',
                      type: 'fraction'
                    },
                    navigation: {
                      nextEl: '.swiper-button-next',
                      prevEl: '.swiper-button-prev',
                    },
                    runCallbacksOnInit: true,
                    slidesPerGroup: 1,

                    breakpoints: {
                      640: {
                        slidesPerView: 2,
                        spaceBetween: 0,
                        slidesPerGroup: 2,
                      },
                      992: {
                        slidesPerView: 3,
                        spaceBetween: 0,
                        slidesPerGroup: 3,
                      },
                      1400: {
                        slidesPerView: 4,
                        spaceBetween: 0,
                        slidesPerGroup: 4,
                      }
                    }
                  }}
                >
                  {
                    prizeList.map((p, index) => (
                      <>
                      <div className='prize-badge-wrapper' key={"prize-wrapper__" + index}>
                        <Prize 
                          id={p.id}
                          tab={index + 1}
                          prize={p} 
                          model="prize"
                          selected={p && p.id === p.id} 
                          selectable 
                          onClick={() => handleShowVideo(p.video, p.videoDesk)}
                          buttonTitle={"Watch " + p.title + "'s story"}
                        />
                      </div>
                      </>
                    ))
                  }
                </Carousel>
              </div>
              <div className='prize-select__nav prize-select__nav--gold'>
                  <button type="button" className='swiper-button-prev'></button>
                  <div className='swiper-pagination'></div>
                  <button type="button" className='swiper-button-next'></button>
                </div>
          </form>
        </div>
      </section>       
          {showVideo && videoSource && ReactDOM.createPortal(
            <FocusTrap>
            <div className="prize-select__video">
              <div className="prize-select__video-content">
                <button tabindex="0" className="modal__close" onClick={handleCloseVideo}></button>
                <video autoPlay playsInline controls>
                  <source src={videoSourceDesk} type="video/mp4" media="(min-width:640px)" />
                  <source src={videoSource} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
            </div>
            </FocusTrap>,
            document.body
          )}
        {/*Carousel End */}
        <SummaryTsandCs className="bg-secondary layout-general"/>
      </>
    );

  }

  const renderLoser = () => {
    return (
      <>
        <Helmet>
          <meta charSet="utf-8" />
          <title>Sorry | Cadbury FC - Game Changing Wins</title>
        </Helmet>

        <section className="layout-general layout-wrapper thankyou loser">
          <div className="layout-container layout-container--center layout-container--slim">
            <h1 className="type-h1 type-h1--smlmargin">You haven't won... yet</h1>
            <div className="goldbar"></div>
            <p className="thankyou__para">
            Sorry you missed out in today’s instant win for match tickets and vouchers. But don’t worry, you can come back tomorrow and try again.            </p>
            <p className="thankyou__para">
            <strong>
            You’re also still in the running to win a game changing player experience. The draw will take place after 28/07/25, so keep an eye on your inbox! 
            </strong>
            </p>
            <p className="thankyou__para">
            In the meantime, why not find out more about our incredible lineup? Click below to hear the inspirational stories that have made them who they are today.            
            </p>
          </div>
          
          {renderNpsBanner(entryPublicId)}
        </section>
            {/*Carousel Start*/}
            <section className="layout-general layout-general--full layout-wrapper overflowx-hidden bg-secondary">
            <div className="layout-container layout-container--center layout-container--wide prize-select">
              <h1 className="type-h1">Meet Players</h1>
              <h1 className="type-h2 type-h2--thin type-h2--gold">who inspire</h1>
              <div className="prize-select__intro">
              <p>Our game changing players wouldn't be where they are today without the kindness of their friends and family. Learn more about their inspirational stories here.</p>
              </div>
              <form>
                <div className="prize-select__list">

                  <Carousel 
                    className="prize-select__carousel"
                    params={{
                      watchOverflow: true,
                      spaceBetween: 30,
                      slidesPerView: 1,
                      centeredSlides: false,
                      pagination: {
                        el: '.swiper-pagination',
                        type: 'fraction'
                      },
                      navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                      },
                      runCallbacksOnInit: true,
                      slidesPerGroup: 1,

                      breakpoints: {
                        640: {
                          slidesPerView: 2,
                          spaceBetween: 0,
                          slidesPerGroup: 2,
                        },
                        992: {
                          slidesPerView: 3,
                          spaceBetween: 0,
                          slidesPerGroup: 3,
                        },
                        1400: {
                          slidesPerView: 4,
                          spaceBetween: 0,
                          slidesPerGroup: 4,
                        }
                      }
                    }}
                  >
                    {
                      prizeList.map((p, index) => (
                        <>
                        <div className='prize-badge-wrapper' tabindex="0" key={"prize-wrapper__" + index} role="button">
                          <Prize 
                            id={p.id}
                            tab={index + 1}
                            prize={p} 
                            model="prize"
                            selected={p && p.id === p.id} 
                            selectable 
                            onClick={() => handleShowVideo(p.video, p.videoDesk)}
                            buttonTitle={"Watch " + p.title + "'s story"}
                          />
                        </div>
                        </>
                      ))
                    }
                  </Carousel>
                </div>
                <div className='prize-select__nav prize-select__nav--gold'>
                    <button type="button" className='swiper-button-prev'></button>
                    <div className='swiper-pagination'></div>
                    <button type="button" className='swiper-button-next'></button>
                  </div>
            </form>
          </div>
        </section>       
            {showVideo && videoSource && ReactDOM.createPortal(
              <FocusTrap>
              <div className="prize-select__video">
                <div className="prize-select__video-content">
                  <button tabindex="0" className="modal__close" onClick={handleCloseVideo}></button>
                  <video autoPlay controls>
                    <source src={videoSourceDesk} type="video/mp4" media="(min-width:640px)" />
                    <source src={videoSource} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                </div>
              </div>
              </FocusTrap>,
              document.body
            )}
          {/*Carousel End */}
        <SummaryTsandCs className="bg-secondary layout-general"/>
      </>
    );
  }

  const renderMopUp = () => {
    return (
      <>
        <Helmet>
          <meta charSet="utf-8" />
          <title>Thank you | Cadbury FC - Game Changing Wins</title>
        </Helmet>

        <section className="layout-general layout-wrapper">
          <div className="layout-container layout-container--center layout-general--full thankyou">
            <h1 className="type-h2">Thank you</h1>
            <p className="thankyou__para">
              We'll be in touch if you're a lucky winner.
            </p>

            <Button title="Back to homepage" href="/" className="mt-20" />
        
          </div>
        </section>
      </>
    )
  }


  return (
    <>
    {
      (entryPublicId && !entry) ? (
        <>
        <Helmet>
            <meta charSet="utf-8" />
            <title>Error | Cadbury FC - Game Changing Wins</title>
          </Helmet>
          <section className="layout-general layout-wrapper">
            <div className="layout-container layout-container--center layout-general--full thankyou">
              <h1 className="type-h2">Error!</h1>
              <p className="thankyou__para">
                Sorry, something went wrong.
              </p>
              <Button title="Back to homepage" href="/" className="mt-20" />
            </div>
          </section>
        </>

      ) : (

        competitionIsMopup ? (
          renderMopUp()
        ) : (
          entry.hasWon ? (
            renderWinner()
          ) : (
            renderLoser()
          )
        )

      )
    }

    </>

  );
}
